import type { DirectoryCreateSchema } from '@repo/schemas/directory/directoryCreate';
import type { DirectoryEditSchemaEditPayload } from '@repo/schemas/directory/directoryEdit';
import type { DirectoryPermissions, DirectoryPrivate, DirectoryPublic } from '@repo/types/directory';
import type { AxiosResponse } from 'axios';

import { axiosInstance } from '#api-client';

export class DirectoryService {
  static async getDirectory(id?: string): Promise<AxiosResponse<DirectoryPrivate>> {
    return await axiosInstance.get(`/api/fs/dir/${id}`);
  }

  static async getDirectoryPermissions(id?: string): Promise<AxiosResponse<DirectoryPermissions>> {
    return await axiosInstance.get(`/api/fs/dir/${id}/getPermissions`);
  }

  static async createDirectory(data: DirectoryCreateSchema): Promise<AxiosResponse<DirectoryPublic>> {
    return await axiosInstance.post('/api/fs/dir', data);
  }

  static async editDirectory(data: DirectoryEditSchemaEditPayload): Promise<AxiosResponse<DirectoryPrivate>> {
    return await axiosInstance.put(`/api/fs/dir/${data.id}`, data);
  }

  static async deleteDirectory(id: string): Promise<AxiosResponse<string>> {
    return await axiosInstance.delete(`/api/fs/dir/${id}`);
  }
}
